<ng-container *ngIf="!link; else asLink">
  <div class="btn-label">
    <div tabindex="1" class="content">
      <div class="img">
        <ng-content select="[img]"></ng-content>
      </div>
      <div class="description">
        {{ title }}
      </div>
    </div>
  </div>
</ng-container>
<ng-template #asLink>
  <a [customRouterLink]="link" class="btn-label">
    <div tabindex="1" class="content">
      <div class="img">
        <ng-content select="[img-link]"></ng-content>
      </div>
      <div class="description">
        {{ title }}
      </div>
    </div>
  </a>
</ng-template>
